"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import Api from "../api/api";
import classNames from "classnames";
import DisablingButton from "../components/disabling_button";
import DocumentThumbnail from "./document_thumbnail";
import EmailTypeAhead from "./email_typeahead";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import WaitingSpinner from "../components/waiting_spinner";
import BouncesMessage from "./bounces_message";
var ExceptionSender = React.createClass({
  propTypes: {
    factoringCompany: React.PropTypes.object
  },
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    const sendNoteToPayeeDefault = this.showPaymentsNetworkExceptionSender();
    let recipients = this.props.parent.sender_address;
    const factoringCompany = this.props.factoringCompany;
    recipients = this.replaceNoReplyRecipientsWithPreferredRecipient(recipients, factoringCompany);
    return {
      subject: this.props.defaultEmail.subject,
      body: this.props.defaultEmail.body,
      recipients,
      sendEmail: !sendNoteToPayeeDefault,
      sendNoteToPayee: sendNoteToPayeeDefault
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.factoringCompany !== newProps.factoringCompany && newProps.factoringCompany) {
      let recipients = this.state.recipients;
      const factoringCompany = newProps.factoringCompany;
      recipients = this.replaceNoReplyRecipientsWithPreferredRecipient(recipients, factoringCompany);
      this.setState({ recipients });
    }
  },
  replaceNoReplyRecipientsWithPreferredRecipient: function(recipients, factoringCompany) {
    if (factoringCompany && factoringCompany.settings) {
      const noReplyEmailAddresses = factoringCompany.settings.no_reply_email_addresses || [];
      const preferredReplyEmailAddress = factoringCompany.settings.preferred_reply_email_address;
      let recipientsList = recipients.split(", ");
      recipientsList = recipientsList.map((recipient) => {
        if (noReplyEmailAddresses.includes(recipient)) {
          return preferredReplyEmailAddress;
        } else {
          return recipient;
        }
      });
      recipients = recipientsList.join(", ");
    }
    return recipients;
  },
  documentToggled: function(doc) {
    var newState = {};
    newState[doc.id] = !this.state[doc.id];
    this.setState(newState);
  },
  enableDocuments: function() {
    var newState = {};
    _.each(this.props.documents, function(doc) {
      newState[doc.id] = false;
    }.bind(this));
    return newState;
  },
  setSendEmail: function() {
    this.setState({ sendEmail: true, sendNoteToPayee: false });
  },
  setPrivateNote: function() {
    this.setState({ sendEmail: false, sendNoteToPayee: false });
  },
  setSendNoteToPayee: function() {
    var newState = { sendNoteToPayee: true, sendEmail: false };
    newState = __spreadValues(__spreadValues({}, newState), this.enableDocuments());
    this.setState(newState);
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.saving }, /* @__PURE__ */ React.createElement("div", { className: "exception-sender" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, this.possibleNoteOrEmailSelection(), this.possibleSendEmail(), this.possiblePrivateNote(), this.possibleSendNoteToPayee())));
  },
  possibleNoteOrEmailSelection: function() {
    if (!this.props.messageSent && !this.props.ignored) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.possibleSendNoteToPayeeToggle()), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: "send-exception-email",
          type: "radio",
          checked: this.state.sendEmail,
          onChange: _.partial(this.setSendEmail)
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "send-exception-email" }, this.showPaymentsNetworkExceptionSender() ? "Send an internal email" : "Send an email")), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: "save-without-emailing",
          type: "radio",
          checked: !this.state.sendEmail && !this.state.sendNoteToPayee,
          onChange: _.partial(this.setPrivateNote)
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "save-without-emailing" }, "Save note and move to waiting without sending an email")));
    }
  },
  showPaymentsNetworkExceptionSender: function() {
    return this.props.carrierInvoice && this.props.carrierInvoice.is_payments_network_submission;
  },
  possibleSendNoteToPayeeToggle: function() {
    if (this.showPaymentsNetworkExceptionSender()) {
      let payee = this.props.carrierInvoice.payments_network_payee_name;
      let toggleTitle = "Send to " + payee + " through Payments Network";
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "input",
        {
          id: "send-payments-network-email",
          type: "radio",
          checked: this.state.sendNoteToPayee,
          onChange: _.partial(this.setSendNoteToPayee)
        }
      ), /* @__PURE__ */ React.createElement("label", { htmlFor: "send-payments-network-email" }, toggleTitle));
    }
  },
  privateNoteFields: function() {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "small-6 column" }, /* @__PURE__ */ React.createElement("label", null, "Private Note"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        valueLink: this.linkState("note")
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "small-4 column" }, /* @__PURE__ */ React.createElement("label", null, "Review On"), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "date",
        valueLink: this.linkState("review_on")
      }
    )));
  },
  possibleSendEmail: function() {
    if (this.state.sendEmail) {
      const contacts = [
        ...this.props.contacts || [],
        ..._.get(this.props.possibleLoad, ["load", "contacts"], [])
      ];
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        BouncesMessage,
        {
          recipients: this.maybeGetRecipients()
        }
      ), /* @__PURE__ */ React.createElement("label", null, "Recipients"), /* @__PURE__ */ React.createElement(
        EmailTypeAhead,
        {
          focusBehavior: "focus",
          onChange: this.recipientsChanged,
          selectByDefault: !this.noDefaultSenderEnabled(),
          recipients: this.maybeGetRecipients(),
          contacts
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Subject"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          valueLink: this.linkState("subject")
        }
      )), this.privateNoteFields(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Message"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          rows: "12",
          valueLink: this.linkState("body")
        }
      )), this.possibleDocuments(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.sendButton(), this.possibleCancel()));
    }
  },
  possiblePrivateNote: function() {
    if (this.props.hasMore) {
      var completionContext = "and go to next group";
    } else {
      var completionContext = "and return to dashboard";
    }
    if (!this.state.sendEmail && !this.state.sendNoteToPayee) {
      return /* @__PURE__ */ React.createElement("div", null, this.privateNoteFields(), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabled: this.state.saving,
          disabledText: "Saving...",
          onClick: this.pause,
          className: "button--progress"
        },
        "Save Note"
      ), /* @__PURE__ */ React.createElement("div", null, completionContext, this.possibleCancel())));
    }
  },
  possibleSendNoteToPayee: function() {
    if (this.state.sendNoteToPayee) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, "Message"), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          rows: "12",
          maxLength: "375",
          valueLink: this.linkState("body")
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, this.sendNoteToPayeeButton(), this.possibleCancel()), /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, "(Message will also be sent via email to facilitate resolution of exceptions)"));
    }
  },
  possibleDocuments: function() {
    if (this.props.documents && this.props.documents.length > 0) {
      return /* @__PURE__ */ React.createElement("div", { className: "small-10 column" }, /* @__PURE__ */ React.createElement("label", null, /* @__PURE__ */ React.createElement("span", null, "Documents to Attach"), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "v3__button-outlined v3__button-small select-all",
          onClick: () => this.toggleAllDocuments(true),
          disabled: this.allDocumentsSelected()
        },
        "Attach All"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "v3__button-outlined v3__button-small select-all",
          onClick: () => this.toggleAllDocuments(false),
          disabled: this.noDocumentsSelected()
        },
        "Detach All"
      )), /* @__PURE__ */ React.createElement("div", { className: "exception-sender__documents" }, _.map(this.props.documents, this.showDocument)));
    }
  },
  sendButton: function() {
    var disabledText = this.state.saving ? "Sending..." : "Enter recipients to send";
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.saving || !this.validEmail(),
        disabledText,
        className: "button--progress",
        onClick: this.sendMessage
      },
      "Send Message"
    );
  },
  sendNoteToPayeeButton: function() {
    var disabledText = this.state.saving ? "Sending..." : "Enter recipients to send";
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabled: this.state.saving || !this.validPayeeMessage(),
        disabledText,
        className: "button--progress",
        onClick: this.sendNoteToPayee
      },
      "Send Message"
    );
  },
  recipientsChanged: function(recipients) {
    this.setState({
      recipients: recipients.join(", ")
    });
  },
  splitRecipients: function() {
    return this.state.recipients.split(", ");
  },
  maybeGetRecipients: function() {
    return this.showPaymentsNetworkExceptionSender() ? "" : this.splitRecipients();
  },
  noDefaultSenderEnabled: function() {
    var settings = Api.Account.currentSettings();
    return settings && settings.disable_carrier_as_default_exception_recipient;
  },
  possibleCancel: function() {
    if (this.props.canCancel) {
      return /* @__PURE__ */ React.createElement("span", { className: "button--cancel-wrapper" }, "or ", /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--cancel",
          onClick: this.props.cancel
        },
        "cancel"
      ));
    }
  },
  selectedDocumentIds: function() {
    return _.pluck(_.select(this.props.documents, function(doc) {
      return !this.state[doc.id];
    }.bind(this)), "id");
  },
  pause: function() {
    this.setState({ saving: true });
    var promise;
    if (this.props.exceptionedItemId) {
      promise = Api.ExceptionedItems.pause(
        this.props.exceptionedItemId,
        this.state.note,
        this.state.review_on,
        this.props.emailMessageId
      );
    } else if (this.props.emailMessageId) {
      promise = Api.ExceptionedItems.pauseEmailMessage(this.props.emailMessageId, this.state.note, this.state.review_on);
    } else {
      promise = Api.ExceptionedItems.pauseDocumentGroup(this.props.documentGroupId, this.state.note, this.state.review_on);
    }
    promise.then(function(result) {
      this.setState({ saving: false });
      this.onComplete();
      return result;
    }.bind(this), function(error) {
      this.setState({ saving: false });
      return error;
    }.bind(this));
  },
  onComplete: function() {
    if (this.props.toDashboardOrNextGroup) {
      this.props.toDashboardOrNextGroup();
    } else {
      this.props.onComplete();
    }
  },
  sendNoteToPayee: function() {
    this.setState({ saving: true });
    let email_id = this.props.emailMessageId || this.props.parentId || this.props.parent.id;
    Api.Email.sendRejectionNote({
      id: email_id,
      recipients: this.props.carrierInvoice.payments_network_payee_email_address,
      subject: this.state.subject,
      exceptioned_item_id: this.props.exceptionedItemId,
      document_ids: this.selectedDocumentIds(),
      document_group_id: this.props.documentGroupId,
      parent_id: this.props.parentId || this.props.parent.id,
      note: this.state.note,
      review_on: this.state.review_on,
      mark_parent_complete: this.props.markParentComplete,
      body: this.state.body
    }).then(function(result) {
      this.setState({ saving: false });
      this.props.onComplete();
      return result;
    }.bind(this), function(error) {
      this.setState({ saving: false });
      return Promise().reject(error);
    }.bind(this));
  },
  sendMessage: function() {
    this.setState({ saving: true });
    Api.Email.send({
      subject: this.state.subject,
      recipients: this.allRecipients(),
      exceptioned_item_id: this.props.exceptionedItemId,
      document_ids: this.selectedDocumentIds(),
      document_group_id: this.props.documentGroupId,
      parent_id: this.props.parentId || this.props.parent.id,
      note: this.state.note,
      review_on: this.state.review_on,
      mark_parent_complete: this.props.markParentComplete,
      body: this.state.body
    }).then(function(result) {
      this.setState({ saving: false });
      this.props.onComplete();
      return result;
    }.bind(this), function(error) {
      this.setState({ saving: false });
      return Promise().reject(error);
    }.bind(this));
  },
  allRecipients: function() {
    return this.state.recipients;
  },
  validEmail: function() {
    return !_.str.isBlank(this.allRecipients());
  },
  validPayeeMessage: function() {
    return !_.str.isBlank(this.state.body);
  },
  showDocument: function(document) {
    var page = _.first(document.pages);
    var classes = classNames({
      "exception-sender__document": true,
      "exception-sender__selected-document": !this.state[document.id]
    });
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classes,
        key: "document-" + document.id,
        onClick: () => {
          this.documentToggled(document);
        }
      },
      /* @__PURE__ */ React.createElement(
        DocumentThumbnail,
        {
          document,
          firstPageOnly: true,
          pageSelected: () => {
          },
          selectedPages: [page]
        }
      )
    );
  },
  documentSelected: function(docId) {
    return !this.state[docId];
  },
  allDocumentsSelected: function() {
    return _.all(this.props.documents, function(doc) {
      return this.documentSelected(doc.id);
    }.bind(this));
  },
  noDocumentsSelected: function() {
    return _.all(this.props.documents, function(doc) {
      return !this.documentSelected(doc.id);
    }.bind(this));
  },
  toggleAllDocuments: function(selected) {
    var newState = {};
    _.each(this.props.documents, function(doc) {
      newState[doc.id] = !selected;
    }.bind(this));
    this.setState(newState);
  }
});
export default ExceptionSender;
